const styles = theme => ({
  root: {
    minHeight: 150,
    width: '100%'
  },
  container: {
    fontSize: 14,
    fontFamily: 'Roboto-Regular',
    color: '#202A38'
  },
  title: {
    fontFamily: 'Roboto-Bold',
    width: '50%',
  },
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    width: '100%',
    padding: '7px 0',
    borderBottom: 'solid 1px #D8DCDF',
    '&:last-of-type': {
      marginBottom: 6,
    }
  },
  headline: {
    fontFamily: 'Roboto-Bold',
    textAlign: 'right',
    backgroundColor: '#F5F6F7',
    minHeight: 46,
    padding: '4px 7px 0 7px',
    borderBottom: 'none',
    '& > span': {
      color: '#80858C',
      fontFamily: 'Roboto-Bold',
    }
  },
  values: {
    width: '25%',
    textAlign: 'right'
  },
})

export default styles;